<template>
  <div class="content">
    <DialogBase panel-title="Thông tin chung" panel-subtitle="Vui lòng điền đầy đủ thông tin" panel-icon="el-icon-document-add" 
        :visible.sync="dialogVisibleEx"
        size="lg"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="80px"
        title="THÊM THỰC ĐƠN TỪ EXCEL"
    >
      <div style="display: flex; gap: 0 20px">
        <el-upload
            ref="upload"
            class="upload-demo"
            action
            multiple
            :auto-upload="false"
            :on-change="importFile"
            :limit="1"
            :on-exceed="handleExceed"
            accept=".xls,.xlsx"
        >
          <el-button @change="importFile()" size="mini" type="primary"
          >Nhập file
          </el-button
          >
        </el-upload>
        <el-button
            @click="dowloadFile()"
            size="mini"
            type="primary"
            style="width: 100px; max-height: 30px"
        >
          <a
              href="https://upload.onekids.edu.vn/sysfiles/other/MAU_THUC_DON_TUAN_50.xlsx"
              style="text-decoration: none; color: white"
          >
            Mẫu File</a
          ></el-button
        >
      </div>

      <div style="margin-top: 50px">
        <el-row type="flex" :gutter="20">
          <el-col :span="12">
            <div class="button-click-left">
              <el-row type="flex" :gutter="10">
                <el-col :span="6">
                  <el-date-picker
                      style="width: 100%"
                      v-model="createTimeClassMenu"
                      type="week"
                      value-format="yyyy-MM-dd"
                      format="Tuần WW"
                      placeholder="Chọn tuần"
                      :clearable="false"
                      @change="getValueDateClassMenu"
                  ></el-date-picker>
                </el-col>

                <el-col :span="18">
                  <el-select
                      style="width: 100%"
                      v-model="listCreateTimeClassMenu"
                      multiple
                      @change="changeWeek()"
                      placeholder="Tuần đã chọn"
                  ></el-select>
                </el-col>
              </el-row>
            </div>
          </el-col>

          <el-col :span="12">
            <div>
              <el-select
                  v-model="createMultiClassMenu.listIdClass"
                  class="button-left"
                  placeholder="Chọn lớp"
                  :clearable="true"
                  style="width: 100%"
                  :multiple="true"
              >
                <el-option
                    v-for="item in classListCommon"
                    :key="item.id"
                    :label="item.className"
                    :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
        </div>

        <template #footer>
        <div style="margin-top: 10px; display: flex; justify-content: flex-end; gap: 10px;">
          <el-button @click="closeDialog" plain class="btn-cancel">
            Đóng
          </el-button>
          <el-button @click="handleChange()" size="mini" type="primary"
          >Tải lên
          </el-button
          >
        </div>
      
    </template>
    </DialogBase>
  </div>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import ClassMenuService from "../../services/ClassMenuService";
import moment from "moment";
import {mapGetters} from "vuex";

export default {
  components: { DialogBase },
  props: {
    dialogVisibleEx: null,
  },
  data() {
    return {
      url: "https://media.onekids.edu.vn/sysfiles/other/MAU_THUC_DON_TUAN_50.xlsx",
      fullscreenLoading: false,
      createTimeClassMenu: "",
      listTimeClassMenu: "",
      listCreateTimeClassMenu: [],
      file: "",
      fileList: [],
      IndexRow: 0,
      loading: "",
      tabListClassMenuDetail: [],
      createMultiClassMenu: {
        weekClassMenu: [],
        listIdClass: "",
      },
    };
  },
  computed: {
    ...mapGetters('classStore', ['classListCommon'])
  },
  created() {
    this.$store.dispatch('classStore/fetchDataClassListCommon')
  },
  watch: {},
  methods: {
    openFullScreen() {
      this.loading = this.$loading({
        lock: true,
        text: "Dữ liệu đang xử lý. Xin vui lòng chờ trong giây lát!",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // setTimeout(() => {
      //   loading.close();
      // }, 2000);
    },
    // dowloadFile() {
    //   const url = this.url;
    //   const link = document.createElement("a");
    //   link.href = url;
    //   link.setAttribute("download", "MAU_THUC_DON_TUAN_50.xlsx"); //or any other extension
    //   document.body.appendChild(link);
    //   link.click();
    // },
    closeDialog() {
      //   this.$refs["createMultiSchedule"].resetFields();
      this.$refs.upload.clearFiles();
      this.file = "";
      this.fileList = [];
      (this.createTimeClassMenu = ""), (this.listCreateTimeClassMenu = []);
      this.createMultiClassMenu.weekClassMenu = [];
      this.createMultiClassMenu.listIdClass = "";
      this.$emit("dialog-close");
      //   this.resetData();
    },
    importFile(file) {
      const validTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
        "application/vnd.ms-excel" // .xls
      ];
      if (!validTypes.includes(file.raw.type)) {
        this.$message.error("Chỉ cho phép upload file Excel!");
        // Sử dụng tham chiếu để loại bỏ file khỏi danh sách hiển thị
        this.$refs.upload.clearFiles(); // Xóa file không hợp lệ
        return;
      }
      this.file = file.raw; // Lưu file hợp lệ
    },
    handleChange() {
      const formData = new FormData();
      const idClass = this.createMultiClassMenu.listIdClass;
      const timeClassMenu = this.createMultiClassMenu.weekClassMenu;
      const file = this.file;

      formData.append("multipartFile", file);
      formData.append("weekClassMenu", timeClassMenu);
      formData.append("listIdClass", idClass);

      if (
          this.createMultiClassMenu.listIdClass.length > 0 &&
          this.createMultiClassMenu.weekClassMenu.length > 0
      ) {
        if (file) {
          this.openFullScreen();
          ClassMenuService.createFileExcel(formData)
              .then((res) => {
                this.loading.close();
                if (res.data) {
                  this.$message({
                    message: "Tải lên file thực đơn thành công",
                    type: "success",
                  });
                  setTimeout(() => {
                    this.closeDialogByButton();
                  }, 500);
                }
              })
              .catch((err) => {
                this.loading.close();
                if (err.response) {
                  if (err.response.status === 400) {
                    this.$message({
                      message: "File thực đơn không đúng Form nhập liệu!",
                      type: "error",
                    });
                  } else {
                    this.$message({
                      message: "Tải lên file thực đơn thất bại",
                      type: "error",
                    });
                  }
                } else {
                  this.$message({
                    message: "File không đúng định dạng.",
                    type: "error",
                  });
                }
              });
        } else {
          this.$message({
            message: "Bạn phải chọn file Excel",
            type: "error",
          });
        }
      } else {
        this.$message({
          message: "Bạn phải chọn lớp và tuần áp dụng",
          type: "error",
        });
      }
    },
    handleExceed() {
      this.$message.warning(`Chỉ được chọn 1 File`);
    },
    // getValueDateClassMenu(createTimeClassMenu) {
    //   this.createTimeClassMenu = createTimeClassMenu;
    //   let a = this.createTimeClassMenu;
    //   let weeknumber = moment(a, "YYYY-MM-DD").isoWeek();
    //   let formatweek =
    //     "Tuần " + weeknumber + "(từ " + moment(a).format("DD-MM-YYYY") + ")";
    //   let indexOfFormatWeek = this.listCreateTimeClassMenu.indexOf(formatweek);
    //   if (indexOfFormatWeek == -1) {
    //     this.listCreateTimeClassMenu.push(formatweek);
    //   } else {
    //     this.listCreateTimeClassMenu.splice(indexOfFormatWeek, 0);
    //   }
    //   let indexOfCreateTimeClassMenu =
    //     this.createMultiClassMenu.weekClassMenu.indexOf(a);
    //   if (indexOfCreateTimeClassMenu == -1) {
    //     this.createMultiClassMenu.weekClassMenu.push(a);
    //   } else {
    //     this.createMultiClassMenu.weekClassMenu.splice(
    //       indexOfCreateTimeClassMenu,
    //       0
    //     );
    //   }
    // },

    getValueDateClassMenu(createTimeClassMenu) {
      // Xử lý ngày trả về từ el-date-picker
      const selectedDate = moment(createTimeClassMenu, "YYYY-MM-DD");

      // Lấy ngày đầu tuần (Thứ Hai) và cuối tuần (Chủ Nhật)
      const startOfWeek = selectedDate.startOf("isoWeek").format("DD-MM-YYYY");
      this.createTimeClassMenu = createTimeClassMenu;
      let a = selectedDate.startOf("isoWeek").format("YYYY-MM-DD");

      let weeknumber = moment(a, "YYYY-MM-DD").isoWeek();

      let formatweek =
          "Tuần " + weeknumber + "(từ " + startOfWeek + ")";
      let indexOfFormatWeek = this.listCreateTimeClassMenu.indexOf(formatweek);
      if (indexOfFormatWeek == -1) {
        this.listCreateTimeClassMenu.push(formatweek);
      } else {
        this.listCreateTimeClassMenu.splice(indexOfFormatWeek, 0);
      }
      let indexOfCreateTimeClassMenu =
          this.createMultiClassMenu.weekClassMenu.indexOf(a);
      if (indexOfCreateTimeClassMenu == -1) {
        this.createMultiClassMenu.weekClassMenu.push(a);
      } else {
        this.createMultiClassMenu.weekClassMenu.splice(
            indexOfCreateTimeClassMenu,
            0
        );
      }
    },
    changeWeek() {
      let c = this.listCreateTimeClassMenu;
      this.createMultiClassMenu.weekClassMenu = [];
      c.forEach((element) => {
        {
          let date = element.slice(-11, -1);
          const newdate = date.split("-").reverse().join("-");
          this.createMultiClassMenu.weekClassMenu.push(newdate);
        }
      });
    },

    closeDialogByButton() {
      this.$refs.upload.clearFiles();
      this.file = "";
      this.fileList = [];
      (this.createTimeClassMenu = ""), (this.listCreateTimeClassMenu = []);
      this.createMultiClassMenu.weekClassMenu = [];
      this.createMultiClassMenu.listIdClass = "";
      this.$emit("dialog-close");

    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog.scss";
</style>
